<template>
    <div id="page-contact">
        <div class="flex flex-wrap -mr-4">
          <!-- Information - Col 1 -->
          <div class="vx-col flex-1" id="account-info-col-1">
            <table style="width: 100%;">
              <thead>
                <tr>
                  <th>Nr faktury</th>
                  <th>Email</th>
                  <th>Kwota</th>
                  <th>Paid at</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(invoice, index) in invoices" :key="index" style="border: 2px solid black;">
                  <td>
                    <a v-if="invoice.is_fakturownia" :href="'https://thomasworks.fakturownia.pl/invoices/'+invoice.invoice_number" target="_blank">{{ invoice.id }}</a>
                    <span v-else>{{ invoice.id }}</span>
                  </td>
                  <td>{{ invoice.email }}</td>
                  <td>{{ (invoice.amount * 0.01).toFixed(2) }}</td>
                  <td>{{ invoice.paid_at }}</td>

                  <td>
                    <button v-if="invoice.is_fakturownia" type="button" name="button_email" class="vs-component vs-button vs-button-primary vs-button-filled" @click="emailFakturowniaInvoice(invoice.id)" style="margin-top: 15px;">
                      <span class="vs-button-backgroundx vs-button--background" style="opacity: 1; left: 20px; top: 20px; width: 0px; height: 0px; transition: width 0.3s ease 0s, height 0.3s ease 0s, opacity 0.3s ease 0s;"></span>
                      <span class="vs-button-text vs-button--text">Faktura @</span>
                      <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%);"></span>
                    </button>
                    <button v-if="invoice.is_fakturownia" type="button" name="button_download" class="vs-component vs-button vs-button-primary vs-button-filled" @click="fetchFakturowniaInvoice(invoice.id)" style="margin-top: 15px;">
                      <span class="vs-button-backgroundx vs-button--background" style="opacity: 1; left: 20px; top: 20px; width: 0px; height: 0px; transition: width 0.3s ease 0s, height 0.3s ease 0s, opacity 0.3s ease 0s;"></span>
                      <span class="vs-button-text vs-button--text">Faktura &#8595;</span>
                      <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%);"></span>
                    </button>
                    <button v-if="!invoice.is_fakturownia" type="button" name="button" class="vs-component vs-button vs-button-primary vs-button-filled" @click="fetchInvoice(invoice.id)" style="margin-top: 15px;">
                      <span class="vs-button-backgroundx vs-button--background" style="opacity: 1; left: 20px; top: 20px; width: 0px; height: 0px; transition: width 0.3s ease 0s, height 0.3s ease 0s, opacity 0.3s ease 0s;"></span>
                      <span class="vs-button-text vs-button--text">Faktura</span>
                      <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%);"></span>
                    </button>
                    <button v-if="!invoice.is_fakturownia" type="button" name="button" class="vs-component vs-button vs-button-primary vs-button-filled" @click="sendToFakturownia(invoice.id)" style="margin-top: 15px;">
                      <span class="vs-button-backgroundx vs-button--background" style="opacity: 1; left: 20px; top: 20px; width: 0px; height: 0px; transition: width 0.3s ease 0s, height 0.3s ease 0s, opacity 0.3s ease 0s;"></span>
                      <span class="vs-button-text vs-button--text">Sent to Fakturownia</span>
                      <span class="vs-button-linex" style="top: auto; bottom: -2px; left: 50%; transform: translate(-50%);"></span>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

    </div>
</template>

<script>
// import flatPickr from 'vue-flatpickr-component';
// import 'flatpickr/dist/flatpickr.css';
// import {Polish as PolishLocale} from 'flatpickr/dist/l10n/pl.js';
// import vSelect from "vue-select";

import axios from "axios";

export default {
    components: {
      // flatPickr,
      // 'v-select': vSelect,
    },
    data() {
        return {
          invoices: [],
          changed: []
        }
    },
    computed: {},
    methods: {
      fetchAll() {
        let url = process.env.VUE_APP_API_ENDPOINT + '/v1/payments/invoices/all';
        this.$http.get(url).then(response => {
          this.invoices = response.data.data;
        });
      },
      fetchInvoice(id) {
        axios({
          url: process.env.VUE_APP_API_ENDPOINT + '/v1/payments/invoice/' + id,
          method: 'GET',
          responseType: 'blob', // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'Faktura_Vitme_' + id + '.pdf');
          document.body.appendChild(link);
          link.click();
        });
      },
      fetchFakturowniaInvoice(id) {
        axios({
          url: process.env.VUE_APP_API_ENDPOINT + '/v1/payments/fakturownia-invoice/' + id,
          method: 'GET',
          responseType: 'blob', // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'Faktura_Vitme_f_' + id + '.pdf');
          document.body.appendChild(link);
          link.click();
        });
      },
      emailFakturowniaInvoice(id){
        axios({
          url: process.env.VUE_APP_API_ENDPOINT + '/v1/payments/fakturownia-email/' + id,
          method: 'GET',
          //responseType: 'blob', // important
        }).then((response) => {
          console.log(response.data.data);
          if(response.data.data.result === 'success') {
            this.$vs.notify({title:'Sukces.',text:'Invoice sent to the email', color:'primary'})
          }
          else {
            this.$vs.notify({title:'Błąd.',text:'Error. Invoice did not send to the email', color:'warning'})
          }
        });
      },
      sendToFakturownia(id){
        axios({
          url: process.env.VUE_APP_API_ENDPOINT + '/v1/payments/to-fakturownia/' + id,
          method: 'GET',
          //responseType: 'blob', // important
        }).then((response) => {
          console.log(response.data.data);
          if(response.data.data.result === 'success') {
            this.$vs.notify({title:'Sukces.',text:'Invoice sent to the Fakturownia', color:'primary'});
            this.fetchAll();
          }
          else {
            this.$vs.notify({title:'Błąd.',text:'Error. Invoice did not send to the Fakturownia', color:'warning'})
          }
        });
      }
    },
    created() {
      this.fetchAll()
    },
}
</script>
